import type { Folder } from '@utils/types/folders/folder';

export type FolderOption = {
  folder: Folder;
  label: string;
  value: string;
  depth: number;
  ancestorIds: number[];
};

export function flattenFolderTree(folders: Folder[] = []): FolderOption[] {
  const result: FolderOption[] = [];
  const visited = new Set<number>();
  const walk = (nodes: Folder[], names: string[], ancestorIds: number[]) => {
    [...nodes]
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
      )
      .forEach(folder => {
        if (visited.has(folder.id)) return;
        visited.add(folder.id);
        const path = [...names, folder.name];
        result.push({
          folder,
          label: path.join(' / '),
          value: String(folder.id),
          depth: names.length,
          ancestorIds
        });
        walk(
          [...(folder.child_folders ?? []), ...(folder.folders ?? [])],
          path,
          [...ancestorIds, folder.id]
        );
      });
  };
  walk(folders, [], []);
  return result;
}
